<template>
	<div id="app" class="app page-admin landing-page" ref="app">
		<MainAdminHeader/>

		<!-- Sidebar -->
		<BlockPageSwitcher :data="pageSwitcher" />

		<main class="site-main site-main--dashboard">
			<router-view/>
		</main>
		<PartBackToTop/>
	</div>
</template>

<script>
import MainAdminHeader from '@/components/main/MainAdminHeader';
import PartBackToTop from '@/components/parts/PartBackToTop';
import BlockPageSwitcher from '@/components/blocks/BlockPageSwitcher';

export default {
	components: {
		MainAdminHeader,
		PartBackToTop,
		BlockPageSwitcher
	},
	data () {
		return {
			pageSwitcher: {}
		};
	}
};
</script>

<style lang="scss" scoped>
.site-main--dashboard {
	display: flex;
	flex-direction: column;
	width: calc(100% - 283px);
	margin-left: auto;

	@include mq($xl) {
		width: 100%;
		margin: 0;
		padding: 0 15px;
	}
}

.app {
	padding-top: 82px;
	padding-bottom: 80px;
	/* height: inherit;*/

	@include mq($xl) {
		padding-top: 80px;
		padding-bottom: 40px;
	}

	@include mq($lg) {
		padding-top: 70px;
	}
}
</style>
